// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class DiscussionServiceInterface {
  constructor() {
    this.service_id = 'discussionservice-1_3';
  }

  // CreateMessageAction, Response: StatusSuccessResponse
  // senderId: int
  // authUserId: String
  // topicId: int
  // messageId: Optional<Integer>
  // message: String
  // anonymous: boolean
  // fromAdmin: boolean
  // messageState: MessageState
  // categoryId: String
  // senderName: String
  createMessage(senderId, authUserId, topicId, messageId, message, anonymous, fromAdmin, messageState, categoryId, senderName, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateMessageAction', { senderId: senderId, authUserId: authUserId, topicId: topicId, messageId: messageId, message: message, anonymous: anonymous, fromAdmin: fromAdmin, messageState: messageState, categoryId: categoryId, senderName: senderName }, success_callback);
  }

  /**
   * CreateMessageReplyAction
   * @param {!string} message
   * @param {!int} replyToMessageId
   * @param {!int} topicId
   * @param {!string} senderName
   * @param {function} success_callback
   * @returns {Promise | Promise<unknown>}
   */
  createMessageReply(message, replyToMessageId, topicId, senderName, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateMessageReplyAction', {
      topicId,
      replyToMessageId,
      message,
      senderName
    }, success_callback);
  }

  /**
   * CreateProposedAnswerAction
   * @param  {!string} proposedAnswer
   * @param {!int} proposedAnswerForMessageId
   * @param {!int} topicId
   * @param {function} success_callback
   * @returns {Promise | Promise<unknown>}
   */
  createProposedAnswer(proposedAnswer, proposedAnswerForMessageId, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateProposedAnswerAction', {
      topicId,
      proposedAnswerForMessageId,
      proposedAnswer
    }, success_callback);
  }

  /**
   * EditMessageReplyAction
   * @param  {!string} message
   * @param {!int} messageReplyId
   * @param {!int} topicId
   * @param {function} success_callback
   * @returns {Promise | Promise<unknown>}
   */
  editMessageReply(message, messageReplyId, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'EditMessageReplyAction', {
      topicId,
      messageReplyId,
      message
    }, success_callback);
  }

  /**
   * EditProposedAnswerAction
   * @param  {!string} proposedAnswer
   * @param {!int} proposedAnswerId
   * @param {!int} topicId
   * @param {function} success_callback
   * @returns {Promise | Promise<unknown>}
   */
  editProposedAnswer(proposedAnswer, proposedAnswerId, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'EditProposedAnswerAction', {
      topicId,
      proposedAnswerId,
      proposedAnswer
    }, success_callback);
  }

  /**
   * DeleteMessageReplyAction
   * @param {!int} messageReplyId
   * @param {!int} topicId
   * @param {function} success_callback
   * @returns {Promise | Promise<unknown>}
   */
  deleteMessageReply(messageReplyId, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteMessageReplyAction', {
      topicId,
      messageReplyId
    }, success_callback);
  }

  /**
   * DeleteProposedAnswerAction
   * @param {!int} proposedAnswerId
   * @param {!int} topicId
   * @param {function} success_callback
   * @returns {Promise | Promise<unknown>}
   */

  deleteProposedAnswer(proposedAnswerId, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteProposedAnswerAction', {
      topicId,
      proposedAnswerId
    }, success_callback);
  }

  // EditMessageTextAction, Response: Boolean
  // messageId: int
  // topicId: int
  // newMessage: String
  editMessage(messageId, topicId, newMessage, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'EditMessageTextAction', { messageId: messageId, topicId: topicId, newMessage: newMessage }, success_callback);
  }

  // SetMessageFavouriteFlagAction, Response: Boolean
  // messageIds: List<Integer>
  // topicId: int
  // favourite: boolean
  setMessageFavouriteFlag(messageIds, topicId, favourite, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetMessageFavouriteFlagAction', { messageIds: messageIds, topicId: topicId, favourite: favourite }, success_callback);
  }

  // SetMessageAnonymousFlagAction, Response: Boolean
  // messageIds: List<Integer>
  // topicId: int
  // anonymous: boolean
  setMessageAnonymousFlag(messageIds, topicId, anonymous, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetMessageAnonymousFlagAction', { messageIds: messageIds, topicId: topicId, anonymous: anonymous }, success_callback);
  }

  // SetMessageStateAction, Response: Boolean
  // messageIds: List<Integer>
  // topicId: int
  // fromMessageState: MessageState
  // toMessageState: MessageState
  setMessageState(messageIds, topicId, fromMessageState, toMessageState, categoryId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetMessageStateAction', { messageIds: messageIds, topicId: topicId, fromMessageState: fromMessageState, toMessageState: toMessageState, categoryId: categoryId }, success_callback);
  }

  // SetTopicMessagesStateAction, Response: Boolean
  // topicId: int
  // fromMessageState: MessageState
  // toMessageState: MessageState
  // excludedMessageIds: Optional<List<Integer>>
  setTopicMessageState(topicId, fromMessageState, toMessageState, excludedMessageIds, fromCategoryId, toCategoryId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SetTopicMessagesStateAction', { topicId: topicId, fromMessageState: fromMessageState, toMessageState: toMessageState, excludedMessageIds: excludedMessageIds, fromCategoryId: fromCategoryId, toCategoryId: toCategoryId }, success_callback);
  }

  // MessagesRequest, Response: Boolean
  // topicId: int
  // filter: MessagesFilter
  // asResponse: Optional<Boolean>
  getMessages(topicId, filter, asResponse, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'MessagesRequest', { topicId: topicId, filter: filter, asResponse: asResponse }, success_callback);
  }

  // DeleteMessageAction, Response: Boolean
  // messageIds: List<Integer>
  // topicId: int
  // messageState: MessageState
  deleteMessage(messageIds, topicId, messageState, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteMessageAction', { messageIds: messageIds, topicId: topicId, messageState: messageState }, success_callback);
  }

  // DeleteAllMessagesAction, Response: Boolean
  // topicId: int
  // messageState: MessageState
  // excludedMessageIds: Optional<List<Integer>>
  deleteAllMessages(topicId, messageState, excludedMessageIds, category_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteAllMessagesAction', { topicId: topicId, messageState: messageState, excludedMessageIds: excludedMessageIds, categoryId: category_id }, success_callback);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  // session_id: int
  subscribeToTopicList(session_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/topics/admin/' + session_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/topics/admin/' + session_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // CreateTopicAction, Response: Boolean
  // sessionId: int
  // name: String
  // state: TopicState
  // autoPublish: boolean
  // topicVariant: Optional<String>
  createTopic(sessionId, name, state, autoPublish, topicVariant, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateTopicAction', { sessionId: sessionId, name: name, state: state, autoPublish: autoPublish, topicVariant: topicVariant }, success_callback);
  }

  // UpdateTopicAction, Response: Boolean
  // topic: Topic
  updateTopic(topic, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateTopicAction', { topic: topic }, success_callback);
  }

  // DeleteTopicAction, Response: Boolean
  // topicId: int
  // sessionId: int
  deleteTopic(topicId, sessionId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteTopicAction', { topicId: topicId, sessionId: sessionId }, success_callback);
  }

  // CreateTopicCategoryAction, Response: Boolean
  // name: String
  // topicId: int
  createTopicCategory(name, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateTopicCategoryAction', { topicId: topicId, name: name }, success_callback);
  }

  // DeleteTopicCategoryAction, Response: Boolean
  // categoryId: String
  // topicId: int
  deleteTopicCategory(categoryId, topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteTopicCategoryAction', { topicId: topicId, categoryId: categoryId }, success_callback);
  }

  // ReorderTopicCategoryAction, Response: Boolean
  // topicId: int
  // beforeCategoryId: String
  // categoryIdToMove: String
  reorderTopicCategory(topicId, beforeCategoryId, categoryIdToMove, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ReorderTopicCategoryAction', { topicId: topicId, beforeCategoryId: beforeCategoryId, categoryIdToMove: categoryIdToMove }, success_callback);
  }

  // ReorderMessageAction, Response: Boolean
  // categoryId: String
  // topicId: int
  // messageIdToMove: int
  reorderMessage(topicId, beforeMessageId, messageIdToMove, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ReorderMessageAction', { topicId: topicId, beforeMessageId: beforeMessageId, messageIdToMove: messageIdToMove }, success_callback);
  }

  // GetTopicCategoriesRequest, Response: Boolean
  // topicId: int
  getTopicCategories(topicId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetTopicCategoriesRequest', { topicId: topicId }, success_callback);
  }

  // subscribe to discussion topic
  // broadcast messages: MessageList, MessageCount
  subscribeToTopicMessages(topic_id, filter, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/messages/admin/' + topic_id, filter: filter } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/messages/admin/' + topic_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  /*
    UpdateTopicHostNameAction = {
      topicId: int,
      sessionId: int,
      hostName: String
    }
  */
  updateTopicHostName(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateTopicHostNameAction', request, success_callback);
  }

  /*
    UpdateEnforceParticipantLabelSelectionAction = {
      topicId: int,
      sessionId: int,
      enforceParticipantLabelSelection: boolean
    }
  */
  updateEnforceParticipantLabelSelection(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateEnforceParticipantLabelSelectionAction', request, success_callback);
  }

  /*
    BlockUsersAction = {
      topicId: int,
      userIds: Set<Integer>,
    }
  */
  blockUsers(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'BlockUsersAction', request, success_callback);
  }

  /*
    UnBlockUsersAction = {
      topicId: int,
      userIds: Set<Integer>,
    }
  */
  unblockUsers(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UnBlockUsersAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   name: String,
   * }
   */
  createDiscussionLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateDiscussionLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   id: Integer,
   *   name: String,
   * }
   */
  updateDiscussionLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateDiscussionLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   id: Integer,
   * }
   */
  deleteDiscussionLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteDiscussionLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   beforeLabelId: Integer
   *   labelIdToMove: Integer,
   * }
   */
  reorderDiscussionLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'ReorderDiscussionLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   * }
   */
  subscribeToDiscussionLabels(request, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: "SubscribeToDiscussionLabelsRequest", data: request };
    var unsubscribe_msg = { service: this.service_id, message: "UnsubscribeFromDiscussionLabelsRequest", data: request };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  /**
   * {
   *   topicId: Integer,
   *   msgId: Integer,
   *   labelId: Integer
   * }
   */
  addDiscussionMessageLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'AddDiscussionMessageLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   msgId: Integer,
   *   labelId: Integer
   * }
   */
  removeDiscussionMessageLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'RemoveDiscussionMessageLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   msgId: Integer,
   *   labelId: Integer
   * }
   */
  approveDiscussionMessageLabel(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'ApproveDiscussionMessageLabelAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   msgIds: Set<Integer>,
   *   labelIds: Set<Integer>
   * }
   */
  addDiscussionMessageLabels(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'AddDiscussionMessageLabelsAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   msgIds: Set<Integer>,
   *   labelIds: Set<Integer>
   * }
   */
  removeDiscussionMessageLabels(request, callback) {
    return ws.sendServiceRequest(this.service_id, 'RemoveDiscussionMessageLabelsAction', request, callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   msgId: Integer,
   *   name: String,
   * }
   */
  updateSenderNameOnHostMessage(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateNameForHostMessageAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   replyId: Integer,
   *   name: String,
   * }
   */
  updateSenderNameOnHostMessageReply(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateNameForHostReplyAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   name: String
   * }
   */
  createModeratorDefinition(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateModeratorDefinitionAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   id: String,
   *   name: String
   * }
   */
  updateModeratorDefinition(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateModeratorDefinitionAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   id: String,
   * }
   */
  deleteModeratorDefinition(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeleteModeratorDefinitionAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   *   beforeModeratorDefinitionId: String,
   *   moderatorDefinitionIdToMove: String,
   * }
   */
  reOrderModeratorDefinition(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ReorderModeratorDefinitionAction', request, success_callback);
  }

  /**
   * {
   *   topicId: Integer,
   * }
   */
  subscribeToModeratorDefinitions(request, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: "SubscribeToModeratorDefinitionsRequest", data: request };
    var unsubscribe_msg = { service: this.service_id, message: "UnsubscribeFromModeratorDefinitionsRequest", data: request };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }
}

export const MessageState = Object.freeze({
  published: 'published',
  hidden: 'hidden',
  in_review: 'in_review',
  reviewed: 'reviewed'
});

export const TopicState = Object.freeze({
  disabled: 'disabled',
  active: 'active',
  readOnly: 'readOnly'
});

export const MessageSortOrder = Object.freeze({
  MOST_LIKES_FIRST: 'MOST_LIKES_FIRST',
  NEWEST_FIRST: 'NEWEST_FIRST',
  OLDEST_FIRST: 'OLDEST_FIRST',
  MANUALLY_ORDERED: 'MANUALLY_ORDERED'
});

export const ShowOnly = Object.freeze({
  deleted: 'deleted',
  published: 'published',
  hidden: 'hidden',
  in_review: 'in_review',
  favourite: 'favourite',
  reviewed: 'reviewed'
});

export const discussionService = new DiscussionServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/discussionservice.js
// module id = kVH8
// module chunks = 1 2 3 4 5 6